import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.primary.background};
  width: 100%;
  max-width: 1000px;
  padding: 15px 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 15px 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 15px;
  }
`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px 5px;
  margin-bottom: 20px;
`;

export const Title = styled(Typography.Title).attrs({ as: 'h2' })`
  font-size: 18px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const LatestAdsButton = styled(CustomLink)`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
  }

  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const LoaderBox = styled.div`
  padding: 15px 0;
`;
